import { STATUS_META } from "@/lib/api";

export const StatusBadge = ({ status, testid }) => {
  const m = STATUS_META[status] || { label: status, bg: "#F4F4F5", text: "#52525B", border: "#E4E4E7" };
  return (
    <span
      data-testid={testid || `status-badge-${status}`}
      className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border whitespace-nowrap"
      style={{ backgroundColor: m.bg, color: m.text, borderColor: m.border }}
    >
      {m.label}
    </span>
  );
};
